<template>
  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
    <!-- Título y Badge opcional -->
    <div class="flex items-center gap-3">
      <h1 class="text-3xl font-bold text-gray-800 tracking-tight">{{ title }}</h1>
      <span 
        v-if="totalCount !== null && totalCount !== undefined" 
        class="px-2.5 py-0.5 text-xs font-semibold rounded-full bg-orange-100 text-orange-700"
      >
        {{ totalCount }}
      </span>
    </div>

    <!-- Barra de Acciones del Header -->
    <div class="flex flex-wrap items-center gap-3 w-full sm:w-auto">
      <!-- Botón Exportar (Dropdown) -->
      <div v-if="hasExport" ref="exportDropdownRef" class="relative">
        <button 
          type="button"
          class="px-4 py-2 bg-white border border-gray-300 hover:border-gray-400 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center gap-2 transition-colors font-medium shadow-sm text-sm"
          @click.stop="toggleExportDropdown"
        >
          <i class="fa fa-download text-gray-500" />
          <span>Exportar</span>
          <i 
            class="fa fa-chevron-down text-[10px] text-gray-400 transition-transform duration-200" 
            :class="{'rotate-180': isExportOpen}"
          />
        </button>

        <!-- Dropdown Menu -->
        <div 
          v-if="isExportOpen" 
          class="absolute top-full right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-100 z-50 py-1.5 animate-in fade-in zoom-in-95 duration-150 overflow-hidden"
        >
          <a 
            :href="exportExcelUrl" 
            target="_blank"
            class="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors"
            @click="isExportOpen = false"
          >
            <div class="w-7 h-7 rounded-lg bg-green-50 flex items-center justify-center shrink-0">
              <i class="fa fa-file-excel text-green-600 text-sm" />
            </div>
            <div class="text-left">
              <div class="font-bold text-xs text-gray-900">Exportar a Excel</div>
              <div class="text-[10px] text-gray-400">Descargar archivo .xlsx</div>
            </div>
          </a>

          <a 
            :href="exportPdfUrl" 
            target="_blank"
            class="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors border-t border-gray-50"
            @click="isExportOpen = false"
          >
            <div class="w-7 h-7 rounded-lg bg-red-50 flex items-center justify-center shrink-0">
              <i class="fa fa-file-pdf text-red-600 text-sm" />
            </div>
            <div class="text-left">
              <div class="font-bold text-xs text-gray-900">Exportar a PDF</div>
              <div class="text-[10px] text-gray-400">Documento imprimible .pdf</div>
            </div>
          </a>
        </div>
      </div>

      <!-- Botón Importar -->
      <button 
        v-if="hasImport"
        type="button"
        class="px-4 py-2 bg-white border border-gray-300 hover:border-gray-400 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center gap-2 transition-colors font-medium shadow-sm text-sm"
        @click="$emit('open-import')"
      >
        <i class="fa fa-upload text-gray-500" />
        <span>Importar</span>
      </button>

      <!-- Botón Crear (Acción Principal) -->
      <Link 
        :href="createUrl" 
        class="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg flex items-center gap-2 transition-colors font-medium shadow-sm text-sm"
      >
        <i class="fa fa-plus" />
        <span>{{ createLabel }}</span>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  name: 'ClientHeader',

  components: {
    Link,
  },

  props: {
    title: {
      type: String,
      default: 'Clientes',
    },
    totalCount: {
      type: Number,
      default: null,
    },
    createUrl: {
      type: String,
      default: '/clients/create',
    },
    createLabel: {
      type: String,
      default: 'Crear Cliente',
    },
    hasExport: {
      type: Boolean,
      default: true,
    },
    hasImport: {
      type: Boolean,
      default: true,
    },
    exportExcelUrl: {
      type: String,
      default: '/clientsReports/excel',
    },
    exportPdfUrl: {
      type: String,
      default: '/clientsReports/pdf',
    },
  },

  emits: ['open-import'],

  data() {
    return {
      isExportOpen: false,
    }
  },

  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },

  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick)
  },

  methods: {
    toggleExportDropdown() {
      this.isExportOpen = !this.isExportOpen
    },

    handleOutsideClick(event) {
      if (this.isExportOpen && this.$refs.exportDropdownRef && !this.$refs.exportDropdownRef.contains(event.target)) {
        this.isExportOpen = false
      }
    },
  },
}
</script>
